import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LoansFormFields } from "web_myplann/Portfolio/Forms/LoansForm/LoansFormFields";
import type { LoanType } from "web_myplann/Portfolio/Forms/LoansForm/loanType";
import { useCreateLoansForm } from "web_myplann/Portfolio/Forms/LoansForm/useCreateLoansForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type CreateLoansFormProps = {
	loanType: LoanType;
};

export const CreateLoansForm = ({ loanType }: CreateLoansFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateLoansForm(loanType);

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<LoansFormFields
				control={form.control}
				loanType={loanType}
				collapseParams
				showRemainsToPay
			/>
		</PortfolioFormShell>
	);
};
